import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/Button';
import { ThemeSwitcher } from '../ThemeSwitcher';
import { LandingVariantSwitcher } from '../LandingVariantSwitcher';
import { NetworkIcon, MenuIcon, XIcon } from 'lucide-react';
const navLinks = [{
  label: 'Features',
  href: '#features'
}, {
  label: 'Use Cases',
  href: '#use-cases'
}, {
  label: 'Pricing',
  href: '#pricing'
}];
export function Navbar() {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`
        fixed top-0 left-0 right-0 z-50 transition-all duration-300
        ${isScrolled ? 'bg-surface-900/80 backdrop-blur-xl border-b border-surface-700' : 'bg-transparent'}
      `}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <NetworkIcon className="w-5 h-5 text-white" />
            </div>
            <span className="text-lg font-bold text-white">StreamGraph</span>
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map(link => <a key={link.label} href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                {link.label}
              </a>)}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-3">
            <LandingVariantSwitcher showLabel={false} />
            <ThemeSwitcher showLabel={false} />
            <Button variant="ghost" size="sm">
              Sign In
            </Button>
            <Button size="sm" onClick={() => navigate('/dashboard')}>Get Started</Button>
          </div>

          {/* Mobile menu button */}
          <button className="md:hidden p-2 text-gray-400 hover:text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" /> : <MenuIcon className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && <div className="md:hidden py-4 border-t border-surface-700">
            <div className="flex flex-col gap-4">
              {navLinks.map(link => <a key={link.label} href={link.href} className="text-gray-400 hover:text-white transition-colors py-2" onClick={() => setIsMobileMenuOpen(false)}>
                  {link.label}
                </a>)}
              <div className="flex flex-col gap-2 pt-4 border-t border-surface-700">
                <LandingVariantSwitcher className="w-full justify-center" />
                <ThemeSwitcher className="w-full justify-center" />
                <Button variant="ghost" className="w-full">
                  Sign In
                </Button>
                <Button className="w-full" onClick={() => navigate('/dashboard')}>Get Started</Button>
              </div>
            </div>
          </div>}
      </div>
    </nav>;
}